import { render, staticRenderFns } from "./adimage.vue?vue&type=template&id=61f94300&"
import script from "./adimage.vue?vue&type=script&lang=js&"
export * from "./adimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports